import { apiSlice } from '../../../../../app/apiSlice';
import { formatDateToISO } from '../../../../../utils/formatDate';

import configSiteUrls from '../../../configs/configSiteUrls';
import { Licitacao, LicitacaoDTO, LicitacaoFormaContratacao, LicitacaoList, LicitacaoListPublicResponse, LicitacaoStatusProcesso } from '../types/Licitacao';

//usei o licitacao como base

const endpointUrl = configSiteUrls.SITE_LICITACAO_EP;
const endpointUrlPublic = configSiteUrls.SITE_LICITACAO_PUBLIC_EP;

interface params {
  data_inicial: string | null;
  data_final: string | null;
  search: string | null;
  page: number | null;
  apply: boolean;
}

function getLicitacoesPublic({ data_inicial, data_final, search, page }: params) {
  const queryParams = new URLSearchParams();

  if (search) queryParams.append('search', search);
  if (data_inicial) queryParams.append('dataInicial', formatDateToISO(data_inicial));
  if (data_final) queryParams.append('dataFinal', formatDateToISO(data_final));
  if (page !== null && page !== undefined) queryParams.append('page', page.toString());

  return {
    url: `${endpointUrlPublic}/all?${queryParams.toString()}`, // remove /all se não existir no backend
    method: 'GET'
  };
}

function getLicitacoes({ search }: { search: string }) {
  return {
    url: `${endpointUrl}/filter?search=${search}`,
    method: 'GET'
  };
}

function addLicitacao(obj: LicitacaoDTO) {
  return {
    url: `${endpointUrl}/create`,
    method: 'POST',
    body: obj
  };
}

function deleteLicitacao({ id }: { id: string }) {
  return {
    url: `${endpointUrl}/${id}`,
    method: 'DELETE'
  };
}
function getLicitacao(id: string) {
  if (!id) {
    return {
      url: '',
      method: ''
    };
  }

  return {
    url: `${endpointUrl}/${id}`,
    method: 'GET'
  };
}
/** */

function getLicitacaoStatusProcessos({ search }: { search: string }) {
  return {
    url: `${endpointUrl}/status/filter?search=${search}`,
    method: 'GET'
  };
}

function getLicitacaoFormaContratacoes({ search }: { search: string }) {
  return {
    url: `${endpointUrl}/formacontratacao/filter?search=${search}`,
    method: 'GET'
  };
}

function getUltimasLicitacoesPublic() {
  return {
    url: `${endpointUrlPublic}/last`, // remove /all se não existir no backend
    method: 'GET'
  };
}

export const licitacaoApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getLicitacoes: query<LicitacaoList[], { search: string }>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getLicitacoes,
      providesTags: ['Licitacao']
    }),

    getLicitacao: query<Licitacao, string>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getLicitacao,
      providesTags: ['Licitacao']
    }),
    getLicitacoesPublic: query<LicitacaoListPublicResponse, params>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getLicitacoesPublic,
      providesTags: ['Licitacao']
    }),
    getUltimasLicitacoesPublic: query<LicitacaoListPublicResponse, void>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getUltimasLicitacoesPublic,
      providesTags: ['Licitacao']
    }),
    addLicitacao: mutation<void, LicitacaoDTO>({
      query: addLicitacao,
      invalidatesTags: ['Licitacao']
    }),
    deleteLicitacao: mutation<void, { id: string }>({
      query: deleteLicitacao,
      invalidatesTags: ['Licitacao']
    }),

    getLicitacaoStatusProcessos: query<LicitacaoStatusProcesso[], { search: string }>({
      query: getLicitacaoStatusProcessos,
      providesTags: ['Licitacao']
    }),

    getLicitacaoFormaContratacoes: query<LicitacaoFormaContratacao[], { search: string }>({
      query: getLicitacaoFormaContratacoes,
      providesTags: ['Licitacao']
    })
  })
});
export const {
  useGetLicitacoesQuery,
  useGetLicitacoesPublicQuery,
  useGetLicitacaoQuery,
  useGetUltimasLicitacoesPublicQuery,
  useAddLicitacaoMutation,
  useDeleteLicitacaoMutation,
  useGetLicitacaoStatusProcessosQuery,
  useGetLicitacaoFormaContratacoesQuery
} = licitacaoApiSlice;
